<template>
  <Header />
  <div id="appCapsule">
    <div class="section mt-2">
      <div class="row g-3">
        <div class="col-6" v-for="service in services" :key="service.id">
          <ServiceView :service="service" />
        </div>
      </div>
    </div>
  </div>
  <Footer />
</template>

<script>
import ServiceView from "@/components/ServiceView";
// import { ref } from "vue";
import axios from "axios";
import Delivery_methods from "@/delivery_methods";
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";

export default {
  name: "Service",
  components: {
    ServiceView,
    Header,
    Footer
  },
  data() {
    return {
      services: [],
    };
  },
  methods: {
    getworkorderdetail: function () {
      let workorder = axios
        .get(`${Delivery_methods.BASE_URL}api/services`)
        .then((response) => {
          this.services = response.data.services;
          this.$cookies.set("staff", { data: response.data.services }, "1h");
        });
      return workorder;
    },
  },
  mounted() {
    
    let staff = this.$cookies.get("staff")
      ? this.$cookies.get("staff")
      : { data: [] };
    if (staff.data.length > 0) {
      this.services = staff.data;
    } else {
      this.getworkorderdetail();
    }
  },
};
</script>

<style scoped></style>